<!--
  --
  -- 車両一覧ページ
  --
  -->
<template>
  <c-container>
    <c-car-filters :filters="filters" :enableCar24Flg="enableCar24Flg" :orgcode="orgcode" />

    <v-row v-if="showCars.length > 0">
      <v-col
        cols="12" sm="6"
        v-for="car in showCars"
        :key="car.id"
      >
        <c-car :stationID="stationID" :car="car"/>
      </v-col>
    </v-row>

    <v-sheet v-else class="pa-4">
      <p>該当する車両は見つかりません。</p>
    </v-sheet>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CCarFilters from '@/components/CCarFilters'
import CCar from './CCar'

import * as api from '@/api'
import * as http from '@/libs/http'

export default {
  name: 'CarList',
  mixins: [
    page('車両一覧')
  ],
  components: {
    CCarFilters,
    CCar
  },

  /**
   * データ取得
   */
  async prepare (to) {
    // ステーションIDを to から取得する
    const stationID = to.params.stid - 0
    const shopID = (stationID / 100) | 0
    const orgcode = to.params.orgcode

    // 車両一覧を取得する
    const resp = await api.getShopCars(shopID, [
      'maker',
      'name',

      'classID',
      'className',
      'chargeText',

      'category',
      'categoryName',
      'type',
      'typeName',

      'image',
      'attributes',
      'hasDetails'
    ])

    let cars = resp.data
    if (resp.status !== http.OK) {
      cars = []
    }

    // 24時間対応車両が存在するか？
    let enableCar24Flg = false
    const keykey = cars.filter(carw => carw.attributes.keykey === 1)
    const vkey = cars.filter(carw => carw.attributes.vkey === 1)
    if (keykey.length > 0 || vkey.length > 0) {
      enableCar24Flg = true
    }

    return {
      orgcode,
      stationID,
      cars,
      enableCar24Flg
    }
  },

  props: {
    orgcode: String,
    stationID: Number,
    cars: Array,
    enableCar24Flg: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    filters: {
      carType: '',
      car24Flg: ''
    }
  }),

  computed: {
    showCars () {
      const filters = this.filters
      let cars = this.cars

      if (filters.carType) {
        cars = cars.filter(car => car.type === filters.carType)
      }

      if (filters.car24Flg) {
        cars = cars.filter(car => {
          if (car.attributes.keykey === 1 || car.attributes.vkey === 1) {
            return true
          }
        })
      }

      return cars
    }
  }
}
</script>
